import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

type CreatedContentActionData = {
	title?: string;
	contentId?: string | number;
};

const getCreatedContentActionData = (
	action: Pick<MessageAction, 'data'>,
): CreatedContentActionData | undefined => action.data as CreatedContentActionData | undefined;

export const getActionTitle = (action: Pick<MessageAction, 'data'>): string =>
	getCreatedContentActionData(action)?.title ?? '';

export const getActionContentId = (action: Pick<MessageAction, 'data'>): string =>
	String(getCreatedContentActionData(action)?.contentId ?? '');
